import { Navigate } from "react-router-dom";
import { Login } from "../pages/Login/Login";
import { ParticipantInfo } from "../pages/Participant/ParticipantInfo";
import { CompanySchedulerIntra } from "../containers/CompanyCalendar/CompanySchedulerIntra";
import { CompanySchedulerIntra2 } from "../containers/CompanyCalendar/CompanySchedulerIntra2";
import { TicketPage } from "../pages/Ticket/TicketPage";

export const publicRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  { path: "/participant/:id", element: <ParticipantInfo /> },
  { path: "/company-calendar", element: <CompanySchedulerIntra /> },
  { path: "/company-calendar-intranet", element: <CompanySchedulerIntra2 /> },
  { path: "/bilet/:token", element: <TicketPage /> },
  // catch-all en sonda olmalı; login path "/" 
  { path: "*", element: <Navigate to="/" replace /> },
];
